const prefixes = ['y', 'z', 'a', 'f', 'p', 'n', 'µ', 'm', '', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];

function parsedString(s: string): string {
  const c = s[s.length - 1];
  return c && prefixes.indexOf(c) > -1 ? s.replace(c, ` ${c}`) : `${s} `;
}
export { parsedString };
